import React, { useContext, useEffect, useState } from "react";
import { DataContext } from "../DataContext";
import CheckoutProduct from "../components/CheckoutProduct";
import { checkAddress, getSalesTaxRate, getShippingFee, updateShippingRate } from "../api/order";
import { PaymentElement, AddressElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useAuth0 } from "@auth0/auth0-react";
import styled from "styled-components";
import Form from "react-bootstrap/Form";
import { Button } from "../styles";
import { capitalizeAddress, baseURL } from "../utils";

const Card = styled.div`
  background-color: var(--white);
  border-radius: 5px;
  margin-bottom: 30px;
  overflow: hidden;
  h2 {
    font-size: 18px;
    padding: 20px 30px 10px 30px;
    margin-bottom: 0;
    background-color: var(--off-white);
    border-bottom: 1px solid var(--border);
    @media only screen and (max-width: 991px) {
      padding: 20px 20px 10px;
    }
  }
  &.contact-info input {
    padding: 12px;
  }
  &.order-summary {
    .total {
      padding-top: 20px;
      padding-bottom: 20px;
      font-size: 18px;
      font-weight: 700;
      border-top: 1px solid var(--border);
      background-color: var(--off-white);
    }
    .order-summary-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      span.order-summary-label {
      }
      span.order-summary-value {
        font-weight: 700;
        text-align: right;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .shipping-address-title-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    font-size: 18px;
    margin-bottom: 0;
    background-color: var(--off-white);
    border-bottom: 1px solid var(--border);
    h2 {
      margin-bottom: 0;
      border: 0;
    }
    & > div {
      padding: 20px 30px 10px;
    }
  }
  .invalid-feedback {
    margin-top: 5px;
    font-size: 16px;
    line-height: 18px;
    color: var(--danger);
  }
  &:last-child {
    margin-bottom: 0;
  }
  .shipping-address {
    display: none;
    &.show {
      display: block;
    }
    &:focus-visible {
      outline: 2px solid var(--dark-grey);
      outline-offset: 5px;
      border-radius: 5px;
    }
  }
  &.address-choice {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin: 10px 0 30px 0;
    padding: 0 30px 0 0;
    font-weight: 700;
    border: 1px solid var(--border);
    background-color: var(--off-white);
    &:hover {
      border: 1px solid var(--green);
    }
    &:last-child {
      margin-bottom: 0;
    }
    i {
      display: block;
      color: var(--green);
      font-size: 24px;
    }

    .address-choice-text {
      padding: 20px;
    }
    .address-choice-checkmark {
      padding: 0 19px;
      align-self: stretch;
      display: none;
      align-items: center;
      border-right: 1px solid var(--border);
    }
    .address-choice-radio {
      padding: 0 19px;
      align-self: stretch;
      display: flex;
      align-items: center;
      border-right: 1px solid var(--border);
      i {
        color: var(--dark-grey);
      }
    }

    &.selected {
      border: 1px solid var(--green);
      .address-choice-checkmark {
        display: flex;
      }
      .address-choice-radio {
        display: none;
      }
    }
  }
  &.billing {
    input,
    select {
      padding: 15px;
    }
    label {
      margin-top: 15px;
      &.name {
        margin-top: 0;
      }
    }
  }
  .state-zip {
    .state,
    .zip {
      width: 100%;
    }
    @media only screen and (min-width: 524px) {
      display: flex;
      justify-content: space-between;
      .state {
        width: 50% !important;
      }
      .zip {
        padding-left: 15px;
        width: 50% !important;
      }
    }
  }
  .shipping-bottom-row {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .form-check {
      label {
        line-height: 20px;
        font-style: italic;
        margin-right: 20px;
      }
      input {
        width: 1em;
      }
    }
    .shipping-verify {
      flex-shrink: 0;
      position: relative;
      display: flex;
      i {
        display: none;
        position: absolute;
        color: var(--white);
        font-size: 24px;
      }
      &.loading {
        opacity: 0.5;
        span {
          visibility: hidden;
        }
        i {
          display: block;
        }
      }
    }
  }
  &.shipping-options {
    .free-shipping-progress-box {
      padding-top: 10px !important;
      padding-bottom: 10px !important;
      border-bottom: 1px solid var(--border);
      .free-shipping-progress-text {
        margin: 10px 0;
        display: block;
        text-align: center;
        &.progress-result {
          font-style: italic;
        }
      }
      .free-shipping-bar-bg {
        height: 10px;
        width: 100%;
        background-color: var(--border);
        border-radius: 100px;
        overflow: hidden;
        .free-shipping-bar-progress {
          background-color: var(--green);
          height: 10px;
          border-radius: 100px;
        }
      }
    }
    .shipping-option-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    input {
      background-color: var(--white) !important;
    }
  }
  input:checked {
    border: 1px solid var(--green) !important;
    background-color: var(--green) !important;
  }
  &.payment-card {
    overflow: visible !important;
  }
`;

const PaymentCard = styled(Card)`
  background-color: transparent;
  padding: 0;
  border: 0;
  box-shadow: none;
  .payment-wrapper {
    background-color: #ffffff;
    border-radius: 5px;
    padding: 20px;
    margin-bottom: 20px;
  }
`;

const INITIAL_BILLING = {
  name: null,
  phone: null,
  address: {
    line1: null,
    line2: null,
    city: null,
    state: null,
    postal_code: null,
    country: "US",
  },
};

export default function CheckoutForm({ clientSecret }) {
  const stripe = useStripe();
  const elements = useElements();
  const { user } = useAuth0();
  const { productsInCart, getSubTotal, settings } = useContext(DataContext);

  const [shippingSection, setShippingSection] = useState("form");

  const [fullName, setFullName] = useState(null);

  const [selectedShippingAddressChoice, setSelectedShippingAddressChoice] = useState(null);
  const [selectedShippingAddress, setSelectedShippingAddress] = useState(null);
  const [enteredShippingAddress, setEnteredShippingAddress] = useState(null);
  const [suggestedShippingAddress, setSuggestedShippingAddress] = useState(null);

  const [shippingRates, setShippingRates] = useState(null);
  const [groundShippingRate, setGroundShippingRate] = useState(null);

  const [selectedShippingOption, setSelectedShippingOption] = useState(null);

  const [salesTaxRate, setSalesTaxRate] = useState(null);

  const [verifyingAddress, setVerifyingAddress] = useState(false);

  const [USPSValidationError, setUSPSValidationError] = useState(null);

  const [billingAddress, setBillingAddress] = useState(INITIAL_BILLING);
  const [billingCheckBox, setBillingCheckBox] = useState(false);

  const [validating, setValidating] = useState(false);
  const [email, setEmail] = useState(user ? user.email : "");
  const [message, setMessage] = useState(null);
  const [isStripeLoading, setIsStripeLoading] = useState(false);

  useEffect(() => {
    if (!stripe || !clientSecret) {
      return;
    }
  }, [stripe]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setValidating(true);
    setIsStripeLoading(true);

    let shipping = {};
    let billing = {};

    if (billingCheckBox) {
      // billing and shipping are different
      const capitalizebBillingAddress = {
        name: billingAddress.name,
        phone: billingAddress.phone,
        address: { ...capitalizeAddress(billingAddress.address) },
      };
      billing = { ...capitalizebBillingAddress, email };
    } else {
      billing = {
        name: fullName,
        phone: null,
        email,
        address: { ...selectedShippingAddress, country: "US" },
      };
    }

    if (selectedShippingAddressChoice === "suggested") {
      shipping = {
        shipping: {
          name: fullName,
          address: { ...selectedShippingAddress, country: "US" },
        },
      };
    }

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: `${baseURL()}/success`,
        payment_method_data: {
          billing_details: {
            ...billing,
          },
        },
        ...shipping,
      },
    });

    if (error.type === "card_error" || error.type === "validation_error") {
      setMessage(error.message);
    } else {
      setMessage("An unexpected error occurred.");
    }

    setIsStripeLoading(false);
  };

  const compareAddresses = (address1, address2) => {
    let exactMatch = true;
    Object.keys(address1).forEach((key) => {
      if (key !== "country" && key !== "line2") {
        if (address1[key].toUpperCase() !== address2[key].toUpperCase()) {
          exactMatch = false;
        }
      }
    });
    return exactMatch;
  };

  const setShippingRateAndSalesTax = async (address) => {
    const { postal_code } = address;
    const { ground, priority } = await getShippingFee(settings.companyZipCode, postal_code);
    setGroundShippingRate(ground.totalBasePrice);
    let groundPrice = null;
    const amountNeededForFreeShipping = settings.freeShippingTarget;
    if (subTotal >= amountNeededForFreeShipping) {
      groundPrice = 0;
    } else {
      groundPrice = ground.totalBasePrice;
    }
    setShippingRates({
      ground: groundPrice,
      priority: priority.totalBasePrice,
    });
    const salesTaxRate = await getSalesTaxRate(address);
    setSalesTaxRate(salesTaxRate);
  };

  const saveShippingAddress = async (address, verified = false) => {
    if (!address) {
      setShippingRates(null);
    }
    setSelectedShippingAddress(capitalizeAddress(address));
    if (verified) {
      setShippingSection("verified");
    }
  };

  const handleShippingAddress = async () => {
    setVerifyingAddress(true);
    const shippingAddressElement = elements.getElement("address", {
      mode: "shipping",
    });
    const enteredAddress = await shippingAddressElement.getValue();

    if (enteredAddress.complete) {
      // save user input address to state
      const entered = enteredAddress.value.address;
      setEnteredShippingAddress(entered);
      setFullName(enteredAddress.value.name);

      const response = await checkAddress(entered);
      if (response.address) {
        const { address } = response;
        // save usps suggested address to state
        let suggested = {
          line1: address.streetAddress,
          line2: null,
          city: address.city,
          state: address.state,
          postal_code: address.ZIPCode,
        };
        if (address.secondaryAddress) {
          suggested = { ...suggested, line2: address.secondaryAddress };
        }
        setSuggestedShippingAddress(suggested);

        const exactMatch = compareAddresses(entered, suggested);

        setShippingRateAndSalesTax(suggested);

        if (!exactMatch) {
          setShippingSection("suggested");
        } else {
          await saveShippingAddress(entered, true);
        }
      } else {
        if (response.message) {
          setShippingSection("error");
          setUSPSValidationError(response.message);
        }
      }
    }
    setVerifyingAddress(false);
  };

  const handleAddressChoice = async (type, address) => {
    setSelectedShippingAddressChoice(type);
    saveShippingAddress(address, true);
  };

  const toggleBillingCheckBox = (value) => {
    setBillingCheckBox(value);
    if (!value) {
      setBillingAddress(INITIAL_BILLING);
    }
  };

  const handleEditShipping = () => {
    setSelectedShippingOption(null);
    saveShippingAddress(null);
    setSelectedShippingAddressChoice(null);
    setShippingSection("form");
  };

  const handleShippingOption = async (option) => {
    setSelectedShippingOption(option);
    const response = await stripe.retrievePaymentIntent(clientSecret);
    await updateShippingRate({
      paymentIntentId: response.paymentIntent.id,
      shippingOption: option,
      cart: productsInCart,
      address: selectedShippingAddress,
    });
  };

  const hideSubmitButton = () => {
    if (billingCheckBox) {
      const { line1, city, state, postal_code } = billingAddress.address;
      return (
        !billingAddress.name ||
        !line1 ||
        !city ||
        !state ||
        !postal_code ||
        isStripeLoading ||
        !stripe ||
        !elements ||
        !email ||
        !selectedShippingAddress ||
        !selectedShippingOption
      );
    } else {
      return isStripeLoading || !stripe || !elements || !email || !selectedShippingAddress || !selectedShippingOption;
    }
  };

  const handleKeyDown = (e, suggested, entered) => {
    if (e.code === "ArrowUp") {
      e.preventDefault();
      handleAddressChoice("suggested", suggested);
    } else if (e.code === "ArrowDown") {
      e.preventDefault();
      handleAddressChoice("entered", entered);
    }
  };

  const paymentElementOptions = {
    layout: { type: "tabs", radios: false },
    fields: {
      billingDetails: "never",
    },
  };

  let freeShippingAvailable = false;

  const amountNeededForFreeShipping = settings.freeShippingTarget;

  let shippingCosts = selectedShippingOption ? shippingRates[selectedShippingOption] : "TBD";

  const subTotal = getSubTotal();

  if (subTotal >= amountNeededForFreeShipping) {
    freeShippingAvailable = true;
  }

  const progressBar = `${(subTotal / amountNeededForFreeShipping) * 100}%`;
  const remaining = amountNeededForFreeShipping - subTotal;

  const salesTax = selectedShippingOption
    ? selectedShippingOption === "ground"
      ? (subTotal + groundShippingRate) * salesTaxRate
      : (subTotal + shippingRates[selectedShippingOption]) * salesTaxRate
    : "TBD";

  const totalCost = shippingCosts === "TBD" || salesTax === "TBD" ? "TBD" : subTotal + shippingCosts + salesTax;

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      <div className="body columns checkout">
        <div className="left-column">
          <Card className="products">
            <h2>Products</h2>
            {productsInCart.map((currentProduct, idx) => (
              <CheckoutProduct key={idx} product={currentProduct}></CheckoutProduct>
            ))}
          </Card>

          <Card>
            <h2>Email</h2>
            <div className="box-padding">
              <Form.Control
                isInvalid={validating && !email}
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                aria-label="Email Address"
              />
              <Form.Control.Feedback type="invalid">Please enter an email address.</Form.Control.Feedback>
            </div>
          </Card>

          <Card>
            <div className="shipping-address-title-row">
              <h2>Shipping Address</h2>
              {shippingSection !== "form" && (
                <div>
                  <Button type="button" className="textWithIcon" onClick={handleEditShipping}>
                    <i class="fa-solid fa-square-pen"></i> edit
                  </Button>
                </div>
              )}
            </div>
            <div className="box-padding">
              <div className={`shipping-address ${shippingSection === "form" && "show"}`}>
                <AddressElement options={{ mode: "shipping", allowedCountries: ["US"] }} />
              </div>

              {suggestedShippingAddress && enteredShippingAddress && (
                <div
                  className={`shipping-address ${shippingSection === "suggested" && "show"}`}
                  onKeyDown={(e) => handleKeyDown(e, suggestedShippingAddress, enteredShippingAddress)}
                  tabIndex={0}
                >
                  <div className="notice">
                    <span className="icon">
                      <i className="fa-solid fa-circle-exclamation"></i>
                    </span>
                    <span className="text">We found a similar mailing address. Please confirm which address to use.</span>
                  </div>
                  <div>USPS Suggested Address</div>
                  <Card
                    onClick={() => handleAddressChoice("suggested", suggestedShippingAddress)}
                    className={`box-padding-2030 address-choice ${selectedShippingAddressChoice === "suggested" && "selected"}`}
                  >
                    {/* <div className="address-choice-checkmark">
                      <i className="fa-solid fa-circle-check"></i>
                    </div>
                    <div className="address-choice-radio">
                      <i class="fa-regular fa-circle"></i>
                    </div> */}

                    <div className="address-choice-text">
                      <div>{suggestedShippingAddress.line1}</div>
                      <div>{suggestedShippingAddress.line2}</div>
                      <div>{`${suggestedShippingAddress.city} ${suggestedShippingAddress.state} ${suggestedShippingAddress.postal_code}`}</div>
                    </div>
                  </Card>
                  <div>Entered Address</div>
                  <Card
                    onClick={() => handleAddressChoice("entered", enteredShippingAddress)}
                    className={`box-padding-2030 address-choice ${selectedShippingAddressChoice === "entered" && "selected"}`}
                  >
                    {/* <div className="address-choice-checkmark">
                      <i className="fa-solid fa-circle-check"></i>
                    </div>
                    <div className="address-choice-radio">
                      <i class="fa-regular fa-circle"></i>
                    </div> */}
                    <div className="address-choice-text">
                      <div>{enteredShippingAddress.line1}</div>
                      <div>{enteredShippingAddress.line2}</div>
                      <div>{`${enteredShippingAddress.city} ${enteredShippingAddress.state} ${enteredShippingAddress.postal_code}`}</div>
                    </div>
                  </Card>
                </div>
              )}

              <div className={`shipping-address ${shippingSection === "verified" && "show"}`}>
                <div>{fullName}</div>
                <div>{selectedShippingAddress?.line1}</div>
                <div>{selectedShippingAddress?.line2}</div>
                <div>{`${selectedShippingAddress?.city} ${selectedShippingAddress?.state} ${selectedShippingAddress?.postal_code}`}</div>
              </div>

              <div className={`shipping-address ${shippingSection === "error" && "show"}`}>
                <div className="notice error">
                  <span className="icon">
                    <i className="fa-solid fa-circle-exclamation"></i>
                  </span>
                  <span className="text">
                    {USPSValidationError}.
                    <span class="usps-error-link">
                      <a onClick={handleEditShipping}>Click here</a> to re-enter your shipping address.
                    </span>
                  </span>
                </div>
                <div>{fullName}</div>
                <div>{enteredShippingAddress?.line1}</div>
                <div>{enteredShippingAddress?.line2}</div>
                <div>{`${enteredShippingAddress?.city} ${enteredShippingAddress?.state} ${enteredShippingAddress?.postal_code}`}</div>
              </div>

              <div className="shipping-bottom-row">
                <Form.Check
                  onChange={(e) => toggleBillingCheckBox(e.target.checked)}
                  type={"checkbox"}
                  id={"separate-billing"}
                  label={"billing address is different than shipping address"}
                />
                {shippingSection === "form" && (
                  <>
                    <Button type="button" className={`shipping-verify ${verifyingAddress && "loading"}`} onClick={handleShippingAddress}>
                      <span>Verify Address</span>
                      <i class="fa-solid fa-spinner fa-spin"></i>
                    </Button>
                  </>
                )}
              </div>
            </div>
          </Card>
          {billingCheckBox && (
            <Card className="billing">
              <h2>Billing Address</h2>
              <div className="box-padding">
                <Form.Group>
                  <Form.Label className="name" for="name">
                    Full name
                  </Form.Label>
                  <Form.Control
                    isInvalid={validating && !billingAddress?.name}
                    type="text"
                    name="name"
                    id="name"
                    value={billingAddress?.name}
                    onChange={(e) =>
                      setBillingAddress({
                        ...billingAddress,
                        name: e.target.value,
                      })
                    }
                  />
                  <Form.Control.Feedback type="invalid">Please provide your full name.</Form.Control.Feedback>
                </Form.Group>

                <Form.Group>
                  <Form.Label for="line1">Address line 1</Form.Label>
                  <Form.Control
                    isInvalid={validating && !billingAddress?.address?.line1}
                    type="text"
                    name="line1"
                    id="line1"
                    value={billingAddress?.address?.line1}
                    aria-label="Address Line 1"
                    onChange={(e) =>
                      setBillingAddress({
                        ...billingAddress,
                        address: {
                          ...billingAddress.address,
                          line1: e.target.value,
                        },
                      })
                    }
                  />
                  <Form.Control.Feedback type="invalid">This field is incomplete.</Form.Control.Feedback>
                </Form.Group>

                <Form.Group>
                  <Form.Label for="line1">Address line 2</Form.Label>
                  <Form.Control
                    type="text"
                    name="line2"
                    id="line2"
                    value={billingAddress?.address?.line2}
                    aria-label="Address Line 2"
                    onChange={(e) =>
                      setBillingAddress({
                        ...billingAddress,
                        address: {
                          ...billingAddress.address,
                          line2: e.target.value,
                        },
                      })
                    }
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label for="city">City</Form.Label>
                  <Form.Control
                    isInvalid={validating && !billingAddress?.address?.city}
                    type="text"
                    name="city"
                    id="city"
                    value={billingAddress?.address?.city}
                    onChange={(e) =>
                      setBillingAddress({
                        ...billingAddress,
                        address: {
                          ...billingAddress.address,
                          city: e.target.value,
                        },
                      })
                    }
                  />
                  <Form.Control.Feedback type="invalid">This field is incomplete.</Form.Control.Feedback>
                </Form.Group>

                <div className="state-zip">
                  <div className="state">
                    <Form.Group>
                      <Form.Label for="state">State</Form.Label>
                      <Form.Select
                        isInvalid={validating && !billingAddress?.address?.state}
                        name="state"
                        id="state"
                        value={billingAddress?.address?.state}
                        onChange={(e) =>
                          setBillingAddress({
                            ...billingAddress,
                            address: {
                              ...billingAddress.address,
                              state: e.target.value,
                            },
                          })
                        }
                      >
                        <option disabled="" value="">
                          Select
                        </option>
                        <option value="AL">Alabama</option>
                        <option value="AK">Alaska</option>
                        <option value="AS">American Samoa</option>
                        <option value="AZ">Arizona</option>
                        <option value="AR">Arkansas</option>
                        <option value="AA">Armed Forces (AA)</option>
                        <option value="AE">Armed Forces (AE)</option>
                        <option value="AP">Armed Forces (AP)</option>
                        <option value="CA">California</option>
                        <option value="CO">Colorado</option>
                        <option value="CT">Connecticut</option>
                        <option value="DE">Delaware</option>
                        <option value="DC">District of Columbia</option>
                        <option value="FL">Florida</option>
                        <option value="GA">Georgia</option>
                        <option value="GU">Guam</option>
                        <option value="HI">Hawaii</option>
                        <option value="ID">Idaho</option>
                        <option value="IL">Illinois</option>
                        <option value="IN">Indiana</option>
                        <option value="IA">Iowa</option>
                        <option value="KS">Kansas</option>
                        <option value="KY">Kentucky</option>
                        <option value="LA">Louisiana</option>
                        <option value="ME">Maine</option>
                        <option value="MH">Marshall Islands</option>
                        <option value="MD">Maryland</option>
                        <option value="MA">Massachusetts</option>
                        <option value="MI">Michigan</option>
                        <option value="FM">Micronesia</option>
                        <option value="MN">Minnesota</option>
                        <option value="MS">Mississippi</option>
                        <option value="MO">Missouri</option>
                        <option value="MT">Montana</option>
                        <option value="NE">Nebraska</option>
                        <option value="NV">Nevada</option>
                        <option value="NH">New Hampshire</option>
                        <option value="NJ">New Jersey</option>
                        <option value="NM">New Mexico</option>
                        <option value="NY">New York</option>
                        <option value="NC">North Carolina</option>
                        <option value="ND">North Dakota</option>
                        <option value="MP">Northern Mariana Islands</option>
                        <option value="OH">Ohio</option>
                        <option value="OK">Oklahoma</option>
                        <option value="OR">Oregon</option>
                        <option value="PW">Palau</option>
                        <option value="PA">Pennsylvania</option>
                        <option value="PR">Puerto Rico</option>
                        <option value="RI">Rhode Island</option>
                        <option value="SC">South Carolina</option>
                        <option value="SD">South Dakota</option>
                        <option value="TN">Tennessee</option>
                        <option value="TX">Texas</option>
                        <option value="UT">Utah</option>
                        <option value="VT">Vermont</option>
                        <option value="VI">Virgin Islands</option>
                        <option value="VA">Virginia</option>
                        <option value="WA">Washington</option>
                        <option value="WV">West Virginia</option>
                        <option value="WI">Wisconsin</option>
                        <option value="WY">Wyoming</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">This field is incomplete.</Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className="zip">
                    <Form.Group>
                      <Form.Label htmlFor="size">ZIP Code</Form.Label>
                      <Form.Control
                        isInvalid={validating && !billingAddress?.address?.postal_code}
                        type="text"
                        name="postal_code"
                        id="postal_code"
                        value={billingAddress?.address?.postal_code}
                        aria-label="Zip Code"
                        onChange={(e) =>
                          setBillingAddress({
                            ...billingAddress,
                            address: {
                              ...billingAddress.address,
                              postal_code: e.target.value,
                            },
                          })
                        }
                      />
                      <Form.Control.Feedback type="invalid">This field is incomplete.</Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </div>
              </div>
            </Card>
          )}
          {shippingRates && shippingSection === "verified" && (
            <Card className="shipping-options">
              <h2>Shipping Options</h2>
              <div className="free-shipping-progress-box box-padding">
                <span className="free-shipping-progress-text">Get Free Shipping on Orders ${amountNeededForFreeShipping}+</span>
                <div className="free-shipping-bar-bg">
                  <div className="free-shipping-bar-progress" style={{ width: `${progressBar}` }}></div>
                </div>
                {freeShippingAvailable ? (
                  <span className="free-shipping-progress-text progress-result">You Qualify for Free Ground Shipping</span>
                ) : (
                  <span className="free-shipping-progress-text progress-result">Your ${remaining} Away</span>
                )}
              </div>
              <div className="shipping-option-selection box-padding">
                <Form>
                  <div className="shipping-option-row">
                    <Form.Check
                      type={"radio"}
                      label={"USPS Ground Advantage"}
                      id={"ground"}
                      name="shipping-options"
                      onChange={() => handleShippingOption("ground")}
                    />
                    <span>
                      <strong>${shippingRates.ground.toFixed(2)}</strong>
                    </span>
                  </div>
                  <div className="shipping-option-row">
                    <Form.Check
                      type={"radio"}
                      label={"USPS Priority Mail"}
                      id={"priority"}
                      name="shipping-options"
                      onChange={() => handleShippingOption("priority")}
                    />
                    <span>
                      <strong>${shippingRates.priority.toFixed(2)}</strong>
                    </span>
                  </div>
                </Form>
              </div>
            </Card>
          )}
          <Card className="order-summary">
            <h2>Order Summary</h2>
            {totalCost && (
              <>
                <div className="box-padding">
                  <div className="order-summary-row">
                    <span className="order-summary-label">Subtotal</span>
                    <span className="order-summary-value">${subTotal.toFixed(2)}</span>
                  </div>
                  <div className="order-summary-row">
                    <span className="order-summary-label">Shipping</span>
                    <span className="order-summary-value">
                      {selectedShippingAddress && typeof shippingCosts === "number" ? `$${shippingCosts.toFixed(2)}` : shippingCosts}
                    </span>
                  </div>
                  {salesTax > 0 && (
                    <div className="order-summary-row">
                      <span className="order-summary-label">Sales Tax</span>
                      <span className="order-summary-value">
                        {selectedShippingAddress && typeof salesTax === "number" ? `$${salesTax.toFixed(2)}` : salesTax}
                      </span>
                    </div>
                  )}
                </div>
                <div className="total box-padding">
                  <div className="order-summary-row">
                    <span className="order-summary-label">Total</span>
                    <span className="order-summary-value">
                      {selectedShippingAddress && typeof totalCost === "number" ? `$${totalCost.toFixed(2)}` : totalCost}
                    </span>
                  </div>
                </div>
              </>
            )}
          </Card>
        </div>
        <div className="right-column">
          <PaymentCard className="sticky payment-card">
            <>
              <div className="payment-wrapper">
                <PaymentElement
                  id="payment-element"
                  options={paymentElementOptions}
                  onChange={(e) => {
                    if (e.complete) {
                      setMessage(null);
                    }
                  }}
                />
              </div>
              <div className="placeOrderButtonWithMessage">
                {message && <div id="payment-message">{message}</div>}
                <Button disabled={hideSubmitButton()} id="submit">
                  <span className={`${isStripeLoading && "loading"}`}>Place Order</span>
                  {isStripeLoading && <i class="fa-solid fa-spinner fa-spin"></i>}
                </Button>
              </div>
            </>
          </PaymentCard>
        </div>
      </div>
    </form>
  );
}
